module.exports = __webpack_public_path__ + "img/XL.e54dda75.jpg";